import React, { useEffect } from "react";
import { useField } from "formik";
import * as yup from "yup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";

import { Handle } from "pages/eligibility/type";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";
import OutlinedDiv from "./outlined";

export const initial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, null> => ({
  [keyFromIdentity(question.identity, parent, index)]: null,
});


export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const key = keyFromIdentity(question.identity, parent, index);
  const value = yup.boolean().nullable();
  return {
    [key]: question.required ? value.required() : value,
  };
};

const InputMessage: React.FC<{ message?: string | null }> = ({ message }) => {
  if (typeof message !== "string") return null;
  if (message.startsWith("<")) {
    return <div dangerouslySetInnerHTML={{ __html: message }} />;
  }
  return <div style={{ lineHeight: "1.4em", textAlign: "justify" }}>{ message }</div>;
};

const BooleanInput = (props: Handle<"FormQuestionBoolean"> & { name: string; }): React.ReactElement => {
  const [field, meta, helpers] = useField(props.name);
  // Validate on transition:
  useEffect(() => () => {
    helpers.setTouched(true);
  }, []);
  const errorClass = meta.touched && !!meta.error ? "color-hc-error" : "";
  const trueText = props.data.custom?.yesText ?? "Yes";
  const falseText = props.data.custom?.noText ?? "No";
  return (
    <FormControl fullWidth variant="outlined" required={props.required} error={meta.touched && !!meta.error} >
      <OutlinedDiv
        label={props.title}
        required={props.required}
        error={meta.touched && !!meta.error}
      >
        <InputMessage message={props.data.message} />
        <RadioGroup row {...field}>
          <FormControlLabel className={errorClass} value="true" control={<Radio className={errorClass}/>} label={trueText} />
          <FormControlLabel className={errorClass} value="false" control={<Radio className={errorClass}/>} label={falseText} />
        </RadioGroup>
      </OutlinedDiv>
      {meta.touched && meta.error && (
        <FormHelperText>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>);
};

BooleanInput.initial = initial;
BooleanInput.validator = validator;
export default BooleanInput;
